 
const seenPopup = localStorage.getItem('seen_popup');
console.log(seenPopup);

const welcomePopModal = document.querySelector(
  '[data-modal-content="welcomePop"]'
);
const welcomeTarget = document.querySelector(
  '[data-modal-target="welcomePop"]'
);

 

window.addEventListener(
  'scroll',
  debounce(function () {
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercentage =
      (scrollPosition / (documentHeight - windowHeight)) * 100; 
    if (scrollPercentage >= 40 && !getCookie('welcomePop')) { 
      modalPop(welcomeTarget);
    }
  }, 50)
);
 

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}